/** Champ du code à 6 chiffres (data-code-totp : repère des preuves). */

interface ChampCodeTotpProps {
  valeur: string;
  onChange: (code: string) => void;
  autoFocus?: boolean;
}

function ChampCodeTotp({ valeur, onChange, autoFocus }: ChampCodeTotpProps) {
  return (
    <>
      <label htmlFor="code-totp" style={{ display: 'block', fontSize: '14px', fontWeight: 500, color: '#334155', marginBottom: '6px' }}>
        Code de vérification
      </label>
      <input
        id="code-totp"
        data-code-totp
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="[0-9]{6}"
        maxLength={6}
        value={valeur}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ''))}
        autoFocus={autoFocus}
        placeholder="123456"
        style={{ width: '100%', padding: '12px', fontSize: '20px', letterSpacing: '6px', textAlign: 'center', border: '1px solid #cbd5e1', borderRadius: '8px', boxSizing: 'border-box' }}
      />
    </>
  );
}

export default ChampCodeTotp;
